export interface OrganizationSettingConfig {
  hasInputFields?: boolean;
  id: string;
  label: string;
  description?: string;
  icon?: string;
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
  presetValues?: number[];
  dropdownValues?: number[];
  isToggle?: boolean;
  attemptsDropdown?: number[];
  timeDropdown?: number[];
  hasEnableToggle?: boolean;
}

export const ORGANIZATION_SETTINGS_CONFIG: OrganizationSettingConfig[] = [
  {
    id: 'sessionTimeout',
    label: 'Session Timeout',
    description: 'Shorter timeouts improve security, but maybe inconvenient to the users.',
    icon: 'bi-clock-history',
    min: 15,
    max: 360,
    step: 15,
    unit: 'min',
  dropdownValues: Array.from({ length: (360 - 15) / 15 + 1 }, (_, i) => 15 + i * 15),
    hasEnableToggle: true,
  },
  {
    id: 'passwordMinLength',
    label: 'Password Minimum Length',
    description: 'Longer passwords improve security. Choose a value that fits your policy.',
    icon: 'bi-shield-lock',
    min: 8,
    max: 256,
    step: 1,
    unit: 'characters',
    dropdownValues: Array.from({ length: (20 - 8) / 1 + 1 }, (_, i) => 8 + i * 1),
    hasEnableToggle: false,
  },
  {
    id: 'passwordLifetime',
    label: 'Password Lifetime',
    description: 'Number of days before a password must be changed. Shorter lifetimes improve security.',
    icon: 'bi-calendar2-week',
    min: 1,
    max: 1095,
    step: 5,
    unit: 'days',
  dropdownValues: Array.from({ length: (180 - 5) / 5 + 1 }, (_, i) => 5 + i * 5),
    hasEnableToggle: true,
  },
  {
    id: 'passwordHistory',
    label: 'Password History',
    description: 'Number of previous passwords that cannot be reused.',
    icon: 'bi-journal-check',
    min: 1,
    max: 10,
    step: 1,
    unit: 'passwords',
    dropdownValues: Array.from({ length: (10 - 1) / 1 + 1 }, (_, i) => 1 + i * 1),
    hasEnableToggle: true,
  },
  {
    id: 'accountLocking',
    label: 'Lock Account',
    description: 'After failed login attempts',
    icon: 'bi-lock-fill',
    attemptsDropdown: [3, 4, 5],
    timeDropdown: Array.from({ length: (60 - 5) / 5 + 1 }, (_, i) => 5 + i * 5),
    hasEnableToggle: true,
    hasInputFields: true,
  },
  {
    id: 'passwordResetEmail',
    label: 'Password Reset Email',
    description: 'Send link to new users and password resets.',
    icon: 'bi-envelope-at',
    isToggle: true,
    hasEnableToggle: true,
  },
];
